module.exports = __webpack_public_path__ + "img/近期活动.48c5b764.jpg";